import { itiMessageService } from '@/iti-core-vue';
import { ItiIconButton, ItiVHeader, ItiList } from '@/iti-core-vuetify';
import { ItiButtonsMaestro } from '@/iti-core-vuetify/components/grid/iti-buttons-maestro';
import { Rol } from '@/shared/dtos/rol';
import { rolesModule } from '@/store';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import RolesFormulario from '../formulario/roles-formulario.vue';
import EventBusType, { EventBus } from '@/shared/services/event-bus';

@Component({
  components: {
    RolesFormulario,
    ItiIconButton,
    ItiList,
  },
})
export default class RolesLista extends Vue {

  public showRolFormulario: boolean = false;

  public rolSeleccionado: Rol = new Rol();
  public get roles() {
    return rolesModule.roles;
  }

  public addHidden = true;
  public loading = false;
  public search = '';
  public refresh: number = 0;

  public get headers() {
    return [
      new ItiVHeader('Name', 'nombre'),
      new ItiVHeader('Description', 'descripcion'),
      new ItiVHeader('activator', '').withSortable(false).withWidth(250),
    ];
  }

  public get buttons() {
    return [
      new ItiButtonsMaestro().buttonEdit,
      new ItiButtonsMaestro().buttonDelete
    ];
  }

  public mounted() {
    // En 0,5 segundos mostramos el botón de añadir para que haga una animáción visible
    setTimeout(() => {
      this.addHidden = false;
    }, 500);
  }

  public newItem() {
    this.openFormulario(new Rol());
  }

  public editItem(item: Rol) {
    this.openFormulario(item);
  }

  public deleteItem(item: Rol) {
    itiMessageService.confirm(
      this.$tc('mensajes.pregunta-borrar') + item.name + '" ?', this.$tc('mensajes.confirmar'),
      (res) => {
        if (res) {
          rolesModule.eliminarRol(item);
        }
      },
    );
  }

  public closeFormulario(item: Rol) {
    this.showRolFormulario = false;
    this.refresh++;
    rolesModule.modificarRol(item); 
  }

  private openFormulario(item: Rol) {
    // Copiamos el objeto para que no se haga un bindeo automatico
    var itemEdit = Object.assign({}, item);

    // Le pasamos los datos a mostrar
    this.rolSeleccionado = itemEdit;

    // Abrimos el modal
    EventBus.$emit(EventBusType.cleanValidators);
    this.showRolFormulario = true;
  }
}
